<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="60">
          <template slot-scope="{row}">
            <el-button v-if="$permission.canRead() || $permission.canReview()" type="text" size="medium" @click.stop="details(row)" icon="el-icon-document" title="详情"></el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <details-dialog ref="dialog"></details-dialog>
  </div>
</template>

<script>

import detailsDialog from '@/components/consult/evaluate/detailsDialog'
import list from '@/components/consult/evaluate/list'
import curdMixins from "@/mixins/curd";
export default {
  name: "evaluate",
  mixins: [curdMixins],
  components: {
    list,
    detailsDialog
  },
  methods: {
    details(row) {
      this.$refs.dialog.openDetailsById(row.EvaluationId);
    },
  }
}
</script>

<style>
</style>